import React, { memo } from "react";
import {
	Modal, ModalBody, ModalFooter,
	Button
} from "reactstrap";

const WaitQuestionAudioFinish = memo( function WaitQuestionAudioFinish({
	isOpen, handler
}) {

	const toggle = () => {
		handler(prev => !prev);
	};

	return (
		<Modal isOpen={isOpen} size="sm">
			<ModalBody>
				<div>Please wait for question audio to be finished.</div>
			</ModalBody>

			<ModalFooter>
				<Button
					color="secondary"
					className="modalCloseBtn"
					onClick={toggle}
				>Ok</Button>
			</ModalFooter>
		</Modal>
	);
});

export default WaitQuestionAudioFinish;